import { connect } from 'react-redux';
import { setLocale } from 'react-redux-i18n';
import Header from 'components/layout/Header';
import ReduxHelper from 'lib/ReduxHelper';

import {
  toggleHeaderDropdown,
  toggleHeaderMenu,
  showOnline,
} from 'data/app/App.actions';

const mapStateToProps = (state, ownProps) => {
  return ReduxHelper.mapStateWithLookups(
    {
      language: state.i18n.locale,
      languagesOpen: state.app.languagesDropdownOpen === true,
      notificationsOpen: state.app.notificationsDropdownOpen === true,
      onlineAuctionsCount: (state.auctions.onlineAuctions || []).length,
      user: state.app.user,
      userProfileOpen: state.app.userProfileDropdownOpen === true,
      showOnline: state.app.showOnline,
    },
    state,
    'partyTypes',
    'memberships'
  );
};

const mapDispatchToProps = dispatch => {
  return {
    setShowOnline: visible => dispatch(showOnline(visible)),
    setLocale: language => dispatch(setLocale(language)),
    toggleHeaderDropdown: (dropdown, forceValue) =>
      dispatch(toggleHeaderDropdown(dropdown, forceValue)),
    toggleHeaderMenu: (menu, forceValue) =>
      dispatch(toggleHeaderMenu(menu, forceValue)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Header);
